// extracted by css-extract-rspack-plugin
export default {"corruptedText":"corrupted-text--eEpUDqtxwag_g18x"};